import { render, staticRenderFns } from "./Orgs.vue?vue&type=template&id=b1fc3e72&scoped=true&"
import script from "./Orgs.vue?vue&type=script&lang=js&"
export * from "./Orgs.vue?vue&type=script&lang=js&"
import style0 from "./Orgs.vue?vue&type=style&index=0&id=b1fc3e72&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fc3e72",
  null
  
)

export default component.exports